import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core';
import { ActionIcons, ButtonItem } from '@modules/ui/action-container/action-container.component';

import { TestCarModel } from '../models/test-car.model';

@Component({
  selector: 'mb-test-car-card',
  templateUrl: './test-car-card.component.html',
  styleUrls: ['./test-car-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TestCarCardComponent {
  @Input() data!: TestCarModel;
  @Input() actions: ButtonItem[] = [
    {
      icon: ActionIcons.DOWNLOAD,
      class: 'btn btn-plain',
    },
  ];
  @Output() actionClick = new EventEmitter<ActionIcons>();
}
